'use client';

import { Box, Chip, Container, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Image } from 'src/components/image';
import { themeConfig } from 'src/theme';

const HISTORY = [
  {
    image: '/assets/images/image-square-bus-1.webp',
    year: '1963',
    description:
      'Puspa Jaya merupakan perusahan keluarga yang bergerak di bidang Jasa Transportasi Darat Bus asal Lampung. Pendiri Puspa Jaya adalah Bapak Ketut Narya yang merupakan seorang transmigran asal Pulau Bali yang bekerja sebagai pegawai negeri saat itu (Guru Sekolah Rakyat). Bapak Ketut Narya mengikuti program transmigrasi pada tahun 1963 dikarenakan terjadi peristiwa erupsi Gunung Agung di wilayah kampung halamannya di Karangasem, Bali dengan tujuan Provinsi Lampung. Setibanya di Lampung, Bapak Ketut Narya beserta rombongan menuju daerah Way Kanan, membuka lahan dan mendirikan perkampungan.',
  },
  {
    image: '/assets/images/image-square-bus-2.webp',
    year: '1978',
    description:
      'Pada tanggal 31 Oktober 1978, Bapak Ketut Narya memulai usaha Angkutan Bus yang bernama Puspa Sari (dengan persetujuan PT. Puspa Sari di Bali) bertempat di Kabupaten Way Kanan, Propinsi Lampung. Usaha diawali dengan satu armada bus dengan trayek Banjit, Way Kanan ke Rajabasa, Bandar Lampung.',
  },
  {
    image: '/assets/images/image-square-bus-2.webp',
    year: '1985',
    description:
      'Setelah mendapatkan respon yang cukup baik dari masyarakat, Bapak I Ketut Narya perlahan mulai melakukan penambahan unit bus medium dan pindah ke Kota Bandar Lampung untuk membuka kantor pertamanya di Rajabasa, dan juga melakukan penambahan rute trayek AKDP ke beberapa kota/kabupaten di provinsi lampung.',
  },
  {
    image: '/assets/images/image-square-bus-2.webp',
    year: '1989',
    description:
      'Mulai membuka divisi bus AKAP rute Lampung - Yogyakarta - Solo dengan bus kelas ekonomi.',
  },
  {
    image: '/assets/images/image-square-bus-3.webp',
    year: '1992',
    description:
      'Pada tahun 1992 estafet kepemimpinan dilanjutkan oleh putra pertama bapak Ketut Narya yaitu Ketut Pasek. Pada era kepemimpinan Bapak Ketut Pasek, dimulai meritis usaha Angkutan Bus secara mandiri dan mendirikan Perusahaan Transportasi Bus dengan nama Puspa Jaya serta membuka pelayanan Bus Non Ekonomi (AC) dan mulai mengembangkan rute ke beberapa daerah di Lampung dan Jawa Timur.',
  },
  {
    image: '/assets/images/image-square-bus-4.webp',
    year: '2000',
    description:
      'Pada tahun 2000an, Puspa Jaya mengembangkan sayap usahanya dibidang jasa pelayanan Bus Pariwisata. Sampai saat ini, Moda transportasi yang dilayani oleh Puspa Jaya adalah Bus AKAP (Antar Kota Antar Provinsi) dan Bus Pariwisata.',
  },
];

export default function View() {
  return (
    <div>
      {/* ============================ */}
      {/* TENTANG PUSPA JAYA TRANSPORT */}
      {/* ============================ */}
      <Container
        sx={{
          padding: {
            xs: '50px 24px',
            md: '100px 0',
          },
        }}
      >
        <div className="relative">
          <Box
            sx={{
              borderRadius: {
                xs: '8px',
                lg: '50px',
              },
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <Image
              src="/assets/images/image-bus-2.webp"
              alt="Promo Puspa Jaya"
              sx={{
                width: '100%',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                left: '0px',
                right: '0px',
                bottom: '0',
                height: '70%',
                background:
                  'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.85) 100%)',
                zIndex: 2,
              }}
            />
          </Box>
          <div className="absolute inset-0" />
        </div>

        <Box
          sx={{
            mt: '-60px',
            position: 'relative',
            zIndex: 10,
          }}
        >
          <div className="flex justify-center">
            <Paper
              elevation={8}
              sx={{
                p: {
                  xs: '10px',
                  md: '20px',
                },
                margin: '0 20px',
                width: {
                  xs: '100%',
                  md: '800px',
                },
                borderRadius: {
                  xs: '8px',
                  lg: '20px',
                },
              }}
            >
              <Typography variant="h6" textAlign="center">
                Puspa Jaya Transport adalah Perusahaan Otobus asal Lampung yang bergerak di bidang
                Jasa Transportasi Darat dengan kendaraan umum Bus. Jasa yang di layanani antara lain
                Bus Antar Kota Antar Provinsi (AKAP) dan Penyewaan Bus Pariwisata
              </Typography>
            </Paper>
          </div>
        </Box>
      </Container>

      <div>
        {/* ===================== */}
        {/* SEJARAH PUSPA JAYA */}
        {/* ===================== */}
        <div className="relative">
          <Box
            sx={{
              borderRadius: '50px',
              overflow: 'hidden',
              background: themeConfig.palette.warning.lighter,
              pt: '50px',
              pb: '200px',
            }}
          >
            <Container className="flex flex-col gap-[50px]">
              <Typography textAlign="center" variant="h3">
                Sejarah Puspa Jaya
              </Typography>
              <div className="flex flex-col gap-[20px] md:gap-[100px]">
                {HISTORY.map((e, i) => (
                  <div className="flex md:items-stretch gap-[20px] md:gap-[40px]" key={i}>
                    <div className="hidden lg:flex flex-none items-center w-[255px]">
                      <Typography
                        sx={{
                          fontSize: '72px',
                          fontWeight: 800,
                          backgroundImage: themeConfig.gradient.primary.bold,
                          WebkitBackgroundClip: 'text',
                          color: 'transparent',
                          display: 'inline-block',
                        }}
                      >
                        {e.year}
                      </Typography>
                    </div>
                    <Box
                      className="w-[40px] flex items-center"
                      sx={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        '&::before':
                          i == 0
                            ? {}
                            : {
                                content: '""',
                                position: 'absolute',
                                width: '1px',
                                top: {
                                  xs: '-10px',
                                  md: '-50px',
                                },
                                left: '50%',
                                bottom: '50%',
                                borderLeft: '3px dashed',
                                borderColor: themeConfig.palette.warning.main,
                                zIndex: 2,
                              },
                        '&::after':
                          i + 1 == HISTORY.length
                            ? {}
                            : {
                                content: '""',
                                position: 'absolute',
                                width: '1px',
                                top: '50%',
                                left: '50%',
                                bottom: {
                                  xs: '-10px',
                                  md: '-50px',
                                },
                                borderLeft: '3px dashed',
                                borderColor: themeConfig.palette.warning.main,
                                zIndex: 2,
                              },
                      }}
                    >
                      <Box
                        sx={{
                          borderRadius: '100px',
                          background: themeConfig.gradient.primary.bold,
                          width: {
                            xs: '22px',
                            md: '38px',
                          },
                          height: {
                            xs: '22px',
                            md: '38px',
                          },
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          position: 'relative',
                          zIndex: 3,
                        }}
                      />
                    </Box>
                    <div className="grow">
                      <div className="lg:hidden mb-[10px]">
                        <Typography
                          sx={{
                            fontSize: '72px',
                            fontWeight: 800,
                            backgroundImage: themeConfig.gradient.primary.bold,
                            WebkitBackgroundClip: 'text',
                            color: 'transparent',
                            display: 'inline-block',
                          }}
                        >
                          {e.year}
                        </Typography>
                      </div>
                      <Typography variant="h6">{e.description}</Typography>
                    </div>
                  </div>
                ))}
              </div>
            </Container>
          </Box>
          <div className="absolute inset-0" />
        </div>

        {/* ===================== */}
        {/* VISI MISI PUSPA JAYA */}
        {/* ===================== */}
        <Box
          id="visimisi"
          sx={{
            mt: '-60px',
            position: 'relative',
            zIndex: 10,
            borderRadius: '50px',
            background: themeConfig.gradient.primary.bold,
            overflow: 'hidden',
            py: '100px',
            '&::after': {
              content: '""',
              position: 'absolute',
              top: { xs: 0, md: '10px' },
              left: '-150px',
              width: '600px',
              height: '600px',
              backgroundImage: 'url("/logo/logo-single.png")',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              opacity: 0.05,
              zIndex: 2,
            },
          }}
        >
          <Container className="flex flex-col gap-[50px]">
            <Typography textAlign="center" variant="h3" color="white">
              Visi & Misi
            </Typography>
            <div className="flex flex-col gap-[50px]">
              <Box
                sx={{
                  borderRadius: '20px',
                  border: '3px solid',
                  borderColor: themeConfig.palette.primary.main,
                  p: '20px',
                }}
              >
                <Typography textAlign="center" variant="h3" color="warning">
                  Visi
                </Typography>
                <Typography textAlign="center" variant="h6" color="white">
                  Menjadi perusahaan transportasi darat yang tumbuh berkelanjutan dengan
                  mengutamakan keselamatan, kenyamanan, dan pelayanan prima untuk terus memberikan
                  kontribusi positif bagi seluruh pemangku kepentingan.
                </Typography>
              </Box>
              <Box
                sx={{
                  borderRadius: '20px',
                  border: '3px solid',
                  borderColor: themeConfig.palette.primary.main,
                  p: '20px',
                }}
              >
                <div className="flex flex-col items-center">
                  <Typography textAlign="center" variant="h3" color="warning">
                    Misi
                  </Typography>
                  <ol className="list-decimal text-white text-[18px] font-bold ml-[16px]">
                    <li>
                      <Typography variant="h6" color="white">
                        Membentuk sumber daya manusia yang kompeten, berintegritas, dan humanis.
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="h6" color="white">
                        Menerapkan standar keselamatan dan kenyamanan yang tinggi dengan menerapkan
                        sistem perawatan armada yang ketat dan berkala.
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="h6" color="white">
                        Membangun ekosistem kemitraan yang sehat.
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="h6" color="white">
                        Menjaga tata kelola perusahaan yang sehat dan adaptif terhadap perkembangan
                        zaman.
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="h6" color="white">
                        Membangun sistem manajemen risiko yang preventif dan tanggap darurat yang
                        cepat.
                      </Typography>
                    </li>
                  </ol>
                </div>
              </Box>
              <Box
                sx={{
                  borderRadius: '20px',
                  border: '3px solid',
                  borderColor: themeConfig.palette.primary.main,
                  p: '20px',
                }}
              >
                <Typography textAlign="center" variant="h3" color="warning">
                  Moto
                </Typography>
                <Typography textAlign="center" variant="h6" color="white">
                  Aman, Nyaman, Terpercaya
                </Typography>
              </Box>
            </div>
          </Container>
        </Box>

        {/* ===================== */}
        {/* PENGHARGAAN PUSPA JAYA */}
        {/* ===================== */}
        <Container id="penghargaan" className="py-[20px] lg:py-[50px] flex flex-col gap-[50px]">
          <Typography variant="h3" textAlign="center">
            Penghargaan
          </Typography>
          <Grid
            container
            spacing="50px"
            direction={{
              xs: 'column',
              md: 'row',
            }}
            sx={{
              alignItems: 'stretch',
            }}
          >
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <Paper
                elevation={8}
                sx={{
                  borderRadius: '20px',
                  p: '20px',
                  height: '100%',
                }}
                className="flex flex-col gap-[20px]"
              >
                <Box
                  sx={{
                    position: 'relative',
                  }}
                >
                  <Image
                    src="/assets/images/image-award-1.webp"
                    ratio="29/23"
                    sx={{
                      borderRadius: '20px',
                    }}
                  />
                  <Chip
                    sx={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: themeConfig.gradient.primary.bold,
                    }}
                    variant="filled"
                    label="2013"
                  />
                </Box>
                <Typography textAlign="center" variant="subtitle2">
                  PO TERBAIK Penghargaan Menteri Perhubungan Perusahaan Angkutan Antar Kota Antar
                  Provinsi (AKAP) Dengan Pelayanan Non Ekonomi terbaik.
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <Paper
                elevation={8}
                sx={{
                  borderRadius: '20px',
                  p: '20px',
                  height: '100%',
                }}
                className="flex flex-col gap-[20px]"
              >
                <Box
                  sx={{
                    position: 'relative',
                  }}
                >
                  <Image
                    src="/assets/images/image-award-2.webp"
                    ratio="29/23"
                    sx={{
                      borderRadius: '20px',
                    }}
                  />
                  <Chip
                    sx={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: themeConfig.gradient.primary.bold,
                    }}
                    variant="filled"
                    label="2014"
                  />
                </Box>
                <div className="flex-grow flex flex-col justify-center">
                  <Typography textAlign="center" variant="subtitle2">
                    Penghargaan Terbaik 1 Pengusaha Angkutan Umum Provinsi Lampung
                  </Typography>
                </div>
              </Paper>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <Paper
                elevation={8}
                sx={{
                  borderRadius: '20px',
                  p: '20px',
                  height: '100%',
                }}
                className="flex flex-col gap-[20px]"
              >
                <Box
                  sx={{
                    position: 'relative',
                  }}
                >
                  <Image
                    src="/assets/images/image-award-3.webp"
                    ratio="29/23"
                    sx={{
                      borderRadius: '20px',
                    }}
                  />
                  <Chip
                    sx={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: themeConfig.gradient.primary.bold,
                    }}
                    variant="filled"
                    label="2021"
                  />
                </Box>
                <div className="flex-grow flex flex-col justify-center">
                  <Typography textAlign="center" variant="subtitle2">
                    Penghargaan Wahana Adhigana Terbaik Nasional
                  </Typography>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
}
